import React from 'react'
import { View } from 'react-native'
import { MAX_WIDTH } from '../../utils/ui'

export function Container({ children, padded = true }: { children: React.ReactNode; padded?: boolean }) {
  return (
    <View
      style={{
        width: '100%',
        maxWidth: MAX_WIDTH,
        alignSelf: 'center',
        paddingHorizontal: padded ? 20 : 0,
      }}
    >
      {children}
    </View>
  )
}
